import React, { useEffect, useState } from 'react';

import { 
    Card,
    CardBody
} from 'reactstrap';

import FullSpinner from 'components/Common/FullSpinner';
import PageBase from 'components/Common/PageBase';
import Filters from './Filters';
import HeaderReport from './HeaderReport';
import TableReport from './TableReport';

import useRequest from 'hooks/useRequest';
import { getAccountAccountingsAll, getAccountingAccounts, getAccountingConcentratesReport, getSalesFolioReport } from 'helpers/backend_helper';

import '../../../../assets/scss/reports/daily-movements.scss';
import moment from 'moment';

const initialPeriod = moment().startOf('month').format('YYYY-MM-DD') + '/' + moment().endOf('month').format('YYYY-MM-DD');

const breadcrumbList = [
    { id: '1', title: 'Administrativo', active: false },
    { id: '2', title: 'Reportes', active: false },
    { id: '3', title: 'Concentrado de cuentas contables', active: true }
];

export default function AccountingConcentratesContainer() {

    const [ accountingAccounts, setAccountingAccounts ] = useState([]);
    const [ period, setPeriod ] = useState(initialPeriod);
    const [ columnOrder, setColumnOrder ] = useState({
        column: '',
        order: ''
    });

    const {
        column,
        order
    } = columnOrder;

    const {
        data,
        isLoading,
        req
    } = useRequest();

    const handleFilters = ({ periodo, tipo, cuenta }) => {
        const config = {
            params: {
                period: periodo,
                tipo: tipo.value,
                cuenta: cuenta.id,
                column,
                order
            }
        };        
        req(getAccountingConcentratesReport(config));
    }

    useEffect(() => {
        getAccountAccountingsAll().then(data => {
            setAccountingAccounts(data);
        })
    }, []);
    
    return (
        <>  
            { isLoading && <FullSpinner /> }
            <PageBase
                titleMeta="Reporte de concentrados de cuentas contables"
                titleBread="Reporte de concentrados de cuentas contables"
                itemsBread={ breadcrumbList }
            >
                <Card>
                    <CardBody>
                        <Filters
                            data={ data }
                            accountingAccounts={ accountingAccounts }
                            handleFilters={ handleFilters }
                            setPeriod={ setPeriod }
                            columnOrder={ columnOrder }
                            period={period}
                        />
                    </CardBody>
                </Card>                
                <Card>
                    <CardBody>                  
                        { data && data.report.length  ? (
                            <>
                                <HeaderReport period={ period }/>
                                <TableReport 
                                    data={ data.report } 
                                    totals={ data.totals }
                                    tipo={ data.tipo }
                                    setColumnOrder={ setColumnOrder }
                                    columnOrder={ columnOrder }
                                />
                            </>
                        ) : <p>No hay datos con el periodo seleccionado</p>}
                    </CardBody>
                </Card>
            </PageBase>
        </>
    );
}